module.exports = __webpack_public_path__ + "img/11.39b3401a.jpg";